import React from 'react';
import { LearningStream } from '../services/streams';

interface UpcomingMilestonesProps {
  streams: LearningStream[];
}

const UpcomingMilestones: React.FC<UpcomingMilestonesProps> = ({ streams }) => {
  // Placeholder for milestones - in real app, fetch from API
  const milestones = [
    { id: '1', name: 'A1 Exam Certification', dueDate: '2025-12-15', stream: 'German', status: 'upcoming' },
    { id: '2', name: 'Complete Linear Algebra', dueDate: '2025-12-20', stream: 'ML_AI', status: 'upcoming' },
  ];

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h3 className="text-xl font-semibold mb-4">Upcoming Milestones</h3>
      <div className="space-y-3">
        {milestones.length > 0 ? (
          milestones.map((milestone) => {
            const daysUntil = Math.ceil(
              (new Date(milestone.dueDate).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)
            );
            return (
              <div key={milestone.id} className="border-l-4 border-primary pl-4 py-2">
                <div className="flex justify-between items-start">
                  <div>
                    <h4 className="font-medium text-gray-900">{milestone.name}</h4>
                    <p className="text-sm text-gray-600">{milestone.stream}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm font-medium text-gray-900">
                      {daysUntil > 0 ? `${daysUntil} days` : 'Due'}
                    </p>
                    <p className="text-xs text-gray-500">
                      {new Date(milestone.dueDate).toLocaleDateString()}
                    </p>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <p className="text-gray-500 text-sm">No upcoming milestones</p>
        )}
      </div>
    </div>
  );
};

export default UpcomingMilestones;

